export function isSpinningWheelFreeProductCoupon (coupon, campaign = {}) {
  return !!coupon && coupon.type === 'FREE_PRODUCT' &&
    (Number(coupon.spinning_wheel_reward_id) > 0 || Number(campaign && campaign.spinning_wheel_reward_id) > 0)
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Marketing/Campaigns/spinningWheelCoupon.js